import { isEmpty, map } from 'lodash'

const getNodes = transformFunction => node => {
  const transformedNode = transformFunction(node)

  if (!isEmpty(node.children)) {
    const children = map(node.children, getNodes(transformFunction))
    return { ...transformedNode, children }
  }

  return transformedNode
}

const transformTree = (array, transformFunction) =>
  map(array, getNodes(transformFunction))

export default transformTree
